// The widget registry: every tile kind other than shortcuts and groups. Its order is the order of the widget
// stylesheets (here and in the bundle); the Add section lists the kinds by name, A to Z. A widget
// is one module in this folder (what its default export declares is described at the top of kit.js) plus a
// stylesheet of the same name, loaded here after kit.css, the styles every widget shares.
import note from './note.js';
import clock from './clock.js';
import countdown from './countdown.js';
import slideshow from './slideshow.js';
import applet from './applet.js';

export const WIDGETS = Object.fromEntries([note, clock, countdown, slideshow, applet].map((w) => [w.kind, w]));

// Resolves once every widget stylesheet has loaded (or failed), so the first render draws styled widgets; the
// sheets go after style.css, so they win over its rules of the same weight. import.meta.resolve applies the page's
// import map, so each sheet is asked for by its versioned address (see server/lib/assets.js); a browser without it (older
// than 2023) has no import maps either and takes the plain address.
const sheet = (name) => import.meta.resolve?.(`./${name}.css`) ?? new URL(`${name}.css`, import.meta.url).pathname;
// A bundled page (production, see server/lib/assets.js) has every widget's styles in its one stylesheet already.
const bundled = !!document.querySelector('link[data-bundle]');
export const stylesReady = bundled ? Promise.resolve() : Promise.all(['kit', ...Object.keys(WIDGETS)].map((name) => new Promise((done) => {
  const link = Object.assign(document.createElement('link'), { rel: 'stylesheet', href: sheet(name) });
  link.addEventListener('load', done);
  link.addEventListener('error', done);
  document.head.append(link);
})));
